// Cartographic palette. The basemap is a fixed light beige and every pin sits on
// a white casing, so these colours are deliberately theme-independent; they live
// here so the canvas, the competitor map and the reporting ramp share one set.
export const MAP_INK = "#0f172a";
export const MAP_INK_SOFT = "#1f2a44";
export const MAP_SELECTED = "#0ca30c";

// Red → green always reads bad → good; the midpoints differ on purpose:
// diverging scales pass through grey at zero ("no change" is neutral),
// sequential scales through amber (a straight red→green blend goes muddy).
export const MAP_RAMP_PALETTE = {
  negative: "#d64545",
  neutral: "#9e9e9e",
  sequentialMid: "#f2c94c",
  positive: "#43a047",
} as const;
